import { Switch, SwitchProps } from 'antd'
import styles from './ASwitch.module.less'
import cls from 'classnames'

type Props = Pick<
  SwitchProps,
  'defaultChecked' | 'checked' | 'size' | 'onChange' | 'className' | 'style'
> & {
  testId?: string
}

const COMPONENT_NAME = 'A-Switch'
function ASwitch(props: Props) {
  const { testId, className, ...switchProps } = props
  const classNames = cls(styles[COMPONENT_NAME], className)
  return <Switch {...switchProps} data-testid={testId} className={classNames} />
}

export default ASwitch
